import {
  AlertTaskConfig,
  AlertTaskConfigBulkUpdate,
  AlertTaskConfigUpsert,
  TaskSetting,
  TaskSettingUpdate,
} from "@/types/task";

import { requestData } from "@/api/api-config";

// Task Settings
export async function fetchTaskSettings(): Promise<TaskSetting | null> {
  return await requestData<TaskSetting>("task/setting", "get");
}

export async function updateTaskSettings(
  data: TaskSettingUpdate,
): Promise<TaskSetting | null> {
  return await requestData<TaskSetting>(
    "task/setting",
    "put",
    {
      json: data,
    },
    false,
  );
}

// Alert Task Configs
export async function fetchAlertTaskConfigs(): Promise<
  AlertTaskConfig[] | null
> {
  return await requestData<AlertTaskConfig[]>("task/alert-config", "get");
}

export async function upsertAlertTaskConfig(
  alertType: string,
  data: AlertTaskConfigUpsert,
): Promise<AlertTaskConfig | null> {
  return await requestData<AlertTaskConfig>(
    `task/alert-config/${alertType}`,
    "put",
    { json: data },
    false,
  );
}

export async function bulkUpsertAlertTaskConfigs(
  data: AlertTaskConfigBulkUpdate,
): Promise<AlertTaskConfig[] | null> {
  return await requestData<AlertTaskConfig[]>(
    "task/alert-config/bulk",
    "put",
    { json: data },
    false,
  );
}
